<template>
  <Dialog v-model:visible="visible" style="width:50%;">
    <div>
      <AlarmTrigger :selectedAlarmPointId="selectedAlarmPointId" @onClose="$emit('update:modelValue', false)"/>
    </div>
  </Dialog>
</template>

<script>
import AlarmTrigger from '@/components/AlarmTrigger.vue'

export default {
  name: 'AlarmTriggerDialog',
  components: { AlarmTrigger },
  props: {
    modelValue: { type: Boolean, required: true },
    selectedAlarmPointId: { type: [String, Number], default: null },
  },
  emits: ['update:modelValue'],
  computed: {
    visible: {
      get() { return this.modelValue },
      set(v) { this.$emit('update:modelValue', v) },
    },
  },
}
</script>
